import { useCallback } from 'react';

import { EMPTY_STRING } from '@e-socna/empty';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { formatAmount } from '../../../utils/format-amount.util';

// Pennylane sends its amounts as decimal strings along with an ISO currency
// code, while the app formats an amount from a currency reference.
export const usePennylaneAmountFormatter = () => {
  const { currencies, currenciesIdMap } = useReferencesContext();

  return useCallback(
    (
      amount: string | null | undefined,
      currencyCode: string | null | undefined,
    ): string => {
      if (!amount) {
        return '-';
      }

      const currency = currencies.find(
        ({ code }) => code.toUpperCase() === currencyCode?.toUpperCase(),
      );

      if (!currency) {
        return `${amount} ${currencyCode ?? EMPTY_STRING}`.trim();
      }

      return formatAmount(
        { value: Number(amount), currencyId: currency._id },
        currenciesIdMap,
      );
    },
    [currencies, currenciesIdMap],
  );
};
